import React from 'react';
import classNames from 'classnames';
import { LegendProps, MapLayerSetting } from '../../api/Contracts';
import LegendSymbols from '../../../legend/LegendSymbols';
import ExpandButton from '../../../../components/button/ExpandButton';
import TopicLayerSettingsCommands from '../TopicLayerSettingsCommands';
import { MapServiceLayerMetadata } from '../../api/useTopicMetadataQuery';

interface SubLayerInfoProps {
  name: string;
  showCommands: boolean;
  metadataLink?: string;
  downloadLink?: string;
}

const SubLayerInfo = ({
  name,
  showCommands,
  metadataLink,
  downloadLink,
}: SubLayerInfoProps) => (
  <div className="topic-layer__item-settings-sublayer">
    <span className="topic-sub-layer-list__item_label" title={name}>
      {name}
    </span>
    {showCommands && (
      <TopicLayerSettingsCommands metadataUrl={metadataLink} downloadUrl={downloadLink} />
    )}
  </div>
);

interface SubLayerSettingProps {
  layer: MapLayerSetting;
  metadata: MapServiceLayerMetadata | null;
  legend: LegendProps[];
  isVisibleAtScale: boolean;
  onExpand: () => void;
  onEnable: () => void;
  isExpandable: boolean;
}

const SubLayerSetting = ({
  layer,
  metadata,
  legend,
  isVisibleAtScale,
  onEnable,
  onExpand,
  isExpandable,
}: SubLayerSettingProps) => {
  const hasExpandableLegend = legend?.length > 1 || legend?.[0]?.label?.length > 0;
  const showCommands = !layer.isGroupLayer && metadata !== null;
  const shouldShowSubLayerInfo = layer.isGroupLayer || hasExpandableLegend;

  return (
    <>
      <div
        className={classNames('topic-sub-layer-list__item', {
          'topic-sub-layer-list__item-not-visible': !isVisibleAtScale,
        })}
      >
        {(isExpandable || hasExpandableLegend) && (
          <ExpandButton expanded={layer.isExpanded} onClick={onExpand} />
        )}
        <input
          type="checkbox"
          checked={layer.isEnabled}
          onChange={onEnable}
          className="form__input topic-sub-layer-list__item_checkbox"
        />
        {shouldShowSubLayerInfo ? (
          <SubLayerInfo
            name={layer.name}
            showCommands={showCommands}
            metadataLink={metadata?.metadataLink}
            downloadLink={metadata?.downloadLink}
          />
        ) : (
          <LegendSymbols
            legend={legend}
            title={layer.name}
            showCommands={showCommands}
            metadataUrl={metadata?.metadataLink}
            downloadUrl={metadata?.downloadLink}
          />
        )}
      </div>
      {layer.isExpanded && hasExpandableLegend && <LegendSymbols legend={legend} />}
    </>
  );
};

export default SubLayerSetting;
